import { findTextOccurrences } from './wordDocumentSearch';

export interface PdfTextSearchMatch {
    pageNumber: number;
    startOffset: number;
    endOffset: number;
}

type TextItem = { str: string };

export function buildPagePlainText(items: TextItem[]): string {
    return items.map((i) => i.str).join('');
}

export async function searchPdfDocument(
    pdfDoc: { numPages: number; getPage: (n: number) => Promise<{ getTextContent: () => Promise<{ items: TextItem[] }> }> },
    query: string,
    caseSensitive = false,
): Promise<PdfTextSearchMatch[]> {
    const needle = query.trim();
    if (!needle) return [];

    const matches: PdfTextSearchMatch[] = [];
    const total = pdfDoc.numPages;

    for (let pageNumber = 1; pageNumber <= total; pageNumber++) {
        const page = await pdfDoc.getPage(pageNumber);
        const content = await page.getTextContent();
        const text = buildPagePlainText(content.items);
        const starts = findTextOccurrences(text, needle, caseSensitive);
        for (const startOffset of starts) {
            matches.push({
                pageNumber,
                startOffset,
                endOffset: startOffset + needle.length,
            });
        }
    }

    return matches;
}
